module.exports = "pegasus_template/assets/color-icon-black.png";